const state = {
  cartAllArray: [],
  cartAllNum: 0,
  cartAllPrice: '0',
};
const actions = {};
const getters = {
  cartInfoShow: function(state) {
    return state.cartAllArray; //JSON.parse(localStorage.getItem('cartInfoShow')); //state.cartAllArray;
  },
  cartAllNumShow: function(state) {
    return state.cartAllNum; //localStorage.getItem('cartAllNumShow'); //state.cartAllNum;
  },
  cartAllPriceShow: function(state) {
    return state.cartAllPrice; //localStorage.getItem('cartAllPriceShow'); //state.cartAllPrice;
  },
};

const mutations = {
  addCartItem(state, cartItem) {
    let isSame = false;
    state.cartAllNum = 0;
    if (state.cartAllArray.length == 0) {
      state.cartAllArray.push(cartItem);
    } else {
      state.cartAllArray.forEach((cartItm) => {
        if (
          cartItm._id == cartItem._id &&
          cartItm.goods_id == cartItem.goods_id
        ) {
          cartItm.buy_num += cartItem.buy_num;
          isSame = true;
        }
      });
      if (!isSame) {
        state.cartAllArray.push(cartItem);
      }
    }
    let total = 0;
    state.cartAllArray.forEach((cartI) => {
      state.cartAllNum += cartI.buy_num;
      total += cartI.buy_num * parseFloat(cartI.price);
    });
    state.cartAllPrice = total.toFixed(2);
    /*localStorage.setItem('cartInfoShow', JSON.stringify(state.cartAllArray));
    localStorage.setItem('cartAllNumShow', state.cartAllNum);
    localStorage.setItem('cartAllPriceShow', state.cartAllPrice);**/
  },
  changeCartBuyNum(state, dict) {
    state.cartAllNum = 0;
    state.cartAllArray.forEach((cartItm) => {
      if (cartItm._id == dict._id && cartItm.goods_id == dict.goods_id) {
        cartItm.buy_num = dict.number;
      }
    });
    let total = 0;
    state.cartAllArray.forEach((cartI) => {
      state.cartAllNum += cartI.buy_num;
      total += cartI.buy_num * parseFloat(cartI.price);
    });
    state.cartAllPrice = total.toFixed(2);
    /*localStorage.setItem('cartInfoShow', JSON.stringify(state.cartAllArray));
    localStorage.setItem('cartAllNumShow', state.cartAllNum);
    localStorage.setItem('cartAllPriceShow', state.cartAllPrice);*/
    console.log('allNum', state.cartAllNum, state.cartAllPrice);
  },
  removeCartItem(state, dict) {
    state.cartAllNum = 0;
    state.cartAllArray.forEach((cartItm, cartIndex) => {
      if (cartItm._id == dict._id && cartItm.goods_id == dict.goods_id) {
        state.cartAllArray.splice(cartIndex, 1);
      }
    });
    let total = 0;
    state.cartAllArray.forEach((cartI) => {
      state.cartAllNum += cartI.buy_num;
      total += cartI.buy_num * parseFloat(cartI.price);
    });
    state.cartAllPrice = total.toFixed(2);
    /*localStorage.setItem('cartInfoShow', JSON.stringify(state.cartAllArray));
    localStorage.setItem('cartAllNumShow', state.cartAllNum);
    localStorage.setItem('cartAllPriceShow', state.cartAllPrice);*/
  },
  removeAllCart(state) {
    state.cartAllPrice = '0.00';
    state.cartAllNum = 0;
    state.cartAllArray = [];
    /*localStorage.removeItem('cartInfoShow');
    localStorage.removeItem('cartAllNumShow');
    localStorage.removeItem('cartAllPriceShow');*/
  },
};
export default {
  state,
  actions,
  getters,
  mutations,
};
